export default {
  root: {
    textTransform: 'capitalize',
  },
};
